const CTA = () => (
  <section className="section cta-section" id="contact">
    <div className="cta-glow" />
    <div className="container cta-inner">
      <span className="section-tag">Let's Work Together</span>
      <h2>Ready to Elevate <span className="red">Your Brand?</span></h2>
      <p>Tell us about your project and let's build something great together.</p>

      <div className="cta-actions">
        <a href="mailto:hello@raddishmedia.com" className="btn-primary btn-lg">
          hello@raddishmedia.com
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
        <a
          href="https://www.instagram.com/raddishmedia?igsh=MXd0eGZxY3ZiMjA3aQ=="
          target="_blank"
          rel="noreferrer"
          className="btn-outline btn-lg"
        >
          Follow Us on Instagram
        </a>
      </div>

      <div className="cta-socials">
        <a href="https://www.instagram.com/raddishmedia?igsh=MXd0eGZxY3ZiMjA3aQ==" target="_blank" rel="noreferrer" className="social-pill">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <circle cx="12" cy="12" r="4"/>
            <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
          </svg>
          Instagram
        </a>
        <a href="https://www.linkedin.com/company/raddish-media/" target="_blank" rel="noreferrer" className="social-pill">
          <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
            <rect x="2" y="9" width="4" height="12"/>
            <circle cx="4" cy="4" r="2"/>
          </svg>
          LinkedIn
        </a>
        <a href="https://x.com/Raddishmedia" target="_blank" rel="noreferrer" className="social-pill">
          <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
          X (Twitter)
        </a>
      </div>
    </div>
  </section>
);

export default CTA;
